
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';
import Spinner from '@/loaders/spinner.vue';

@Options({
  props: {
    msg: String,
    msgSpinner: { type: String },
  },
  components: { Spinner },
  computed: {},
  methods: {
    isLoading() {
      this.isLoading = true;
    },
  },
  data() {
    return {
      isLoading: true,
      setProfile: [],
    };
  },
  mounted() {
    axios.get('https://api.mpmalak.com/profile.json').then((response) => {
      this.setProfile = response.data;
      if (!this.setProfile) {
        this.isLoading = true;
      }
    });
    this.isLoading = false;
  },
})
export default class Welcome extends Vue {}
